import * as React from 'react'
import { View, Text, Platform } from 'react-native'
import styled from '@theme/styled-components'

import Button from '@components/button/Button'
import CGU from '@components/cgu/CGU'

import useI18n from '@i18n/useI18n'
import useBreakpoint from '@utils/useBreakpoints'
import Select from '@components/select/Select'

interface Props {
  onRoleSelected: (role: UserRole) => void
}

const SelectRole = ({ onRoleSelected }: Props) => {
  const i18n = useI18n()
  const [, bp] = useBreakpoint()

  const renderRole = (role: UserRole) =>
    bp === 'phone' ? (
      <Button
        label={i18n.t(`screens.login.roleSection.${role.toLowerCase()}`)}
        onClick={() => onRoleSelected(role)}
        status="active"
        color="light"
      />
    ) : (
      <Select
        label={i18n.t(`screens.login.roleSection.${role.toLowerCase()}`)}
        onClick={() => onRoleSelected(role)}
        selectStyle="bold"
      />
    )

  return (
    <MainContainer>
      <Title>{i18n.t(`screens.login.roleSection.${bp === 'phone' ? 'roleSubTitle' : 'title'}`)}</Title>
      <Buttons>
        {Platform.OS === 'web' && <SelectContainer>{renderRole('EXPOSANT')}</SelectContainer>}

        <SelectContainer>{renderRole('PRESTATAIRE')}</SelectContainer>

        {Platform.OS === 'web' && <SelectContainer>{renderRole('ORGANISATEUR')}</SelectContainer>}

        <SelectContainer isLast>{renderRole('VIPARIS')}</SelectContainer>
      </Buttons>
      <Links>
        <CGU />
      </Links>
    </MainContainer>
  )
}

export default SelectRole

const MainContainer = styled(View)`
  ${(props) => props.theme.breakpoint !== 'phone' && `flex: 1;`}
  ${(props) => (props.theme.breakpoint === 'phone' ? `padding-top: 16px;` : `padding: 0px 48px;`)}
  justify-content: center;
`

const Title = styled(Text)`
  ${(props) => (props.theme.breakpoint === 'phone' ? props.theme.fonts.Body : props.theme.fonts.Caption1)};
  ${(props) =>
    props.theme.breakpoint === 'phone'
      ? `
      color: ${props.theme.colors.background};
      align-self: center;
      margin-bottom: 16px;`
      : `
      color: ${props.theme.colors.secondaryText};
      font-size: 28px;
      margin-bottom: 40px;
      line-height: 32px;`}
`

const Buttons = styled(View)`
  ${(props) => props.theme.breakpoint !== 'phone' && `max-width: 490px;`}
`

const SelectContainer = styled(View)<{ isLast?: boolean }>`
  ${(props) => !props.isLast && `margin-bottom: ${props.theme.breakpoint === 'phone' ? 8 : 24}px;`}
`

const Links = styled(View)`
  margin-top: 24px;
`
